/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Import_Status_Loading_ProjectInputs */



/**
* | output |
* | --- |
* | "Loading project..." |
*
* @param {Iconik_Import_Status_Loading_ProjectInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_import_status_loading_project = /** @type {((inputs?: Iconik_Import_Status_Loading_ProjectInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Import_Status_Loading_ProjectInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chargement du projet...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projekt wird geladen...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Caricamento del progetto in corso...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Загрузка проекта...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cargando proyecto...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("项目正在加载...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトを読み込んでいます...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोजेक्ट लोड हो रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Carregando projeto...")
	return /** @type {LocalizedString} */ ("Loading project...")
});